export default __webpack_public_path__ + "static/media/hht2_ep2_speaking_02.4b185b56.png";